import { render, staticRenderFns } from "./PerfectStoreTips.vue?vue&type=template&id=1f525fb4&scoped=true&"
import script from "./PerfectStoreTips.vue?vue&type=script&lang=js&"
export * from "./PerfectStoreTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f525fb4",
  null
  
)

export default component.exports